import Icon from "../../components/Icon";
import LoadingBlock from "../../components/LoadingBlock";
import EmptyState from "../../components/EmptyState";
import { useApi } from "../../hooks/useApi";
import { getChangelog } from "../../api/announcementService";
import { formatDate } from "../../utils/formatters";

export default function ChangelogPage() {
  const changelog = useApi(() => getChangelog(), []);
  const releases = changelog.data?.data || [];
  const currentVersion = changelog.data?.current_version;

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">What's New</h1>
          <div className="page-sub">Product updates and release history</div>
        </div>
        {currentVersion && (
          <div className="page-actions">
            <span className="badge badge-info">
              <Icon name="sparkles" size={12} /> Current version v{currentVersion}
            </span>
          </div>
        )}
      </div>

      {changelog.loading ? (
        <div className="card"><div className="card-body"><LoadingBlock rows={5} /></div></div>
      ) : releases.length === 0 ? (
        <EmptyState icon="sparkles" title="No release notes yet" hint="Product updates will show up here as they ship." />
      ) : (
        <div className="col gap-md">
          {releases.map((r) => (
            <div key={r.id} className="card">
              <div className="card-body">
                <div className="row gap-sm" style={{ alignItems: "center", marginBottom: 8 }}>
                  {r.version && <span className="badge badge-info">v{r.version}</span>}
                  <span className="t-primary fw-600">{r.title}</span>
                  <span className="t-muted text-xs" style={{ marginLeft: "auto" }}>
                    {r.published_at ? formatDate(r.published_at) : ""}
                  </span>
                </div>
                <div className="t-muted" style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{r.body}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
